import { doc, getDoc } from 'firebase/firestore'
import { getFunctions, httpsCallable } from 'firebase/functions'
import app, { db } from './firebase'
import { aucklandDayKey } from './liveWorkService'

export interface ThanksSplashInfo {
  dayKey: string
  imageUrl: string
  subtitle: string
}

type GetThanksSplashResponse = {
  success: boolean
  dayKey?: string
  imageUrl?: string
  subtitle?: string
  message?: string
}

/**
 * Today's shared Carpe Diem thanks splash.
 * Prefer Firestore cache; call getThanksSplash if missing (triggers generation).
 */
export async function fetchTodaysThanksSplash(): Promise<ThanksSplashInfo | null> {
  const dayKey = aucklandDayKey()
  try {
    const snap = await getDoc(doc(db, 'thanksSplash', dayKey))
    if (snap.exists()) {
      const data = snap.data() as { imageUrl?: string; subtitle?: string; dayKey?: string }
      if (typeof data.imageUrl === 'string' && data.imageUrl) {
        return {
          dayKey: data.dayKey || dayKey,
          imageUrl: data.imageUrl,
          subtitle: typeof data.subtitle === 'string' ? data.subtitle : 'See you tomorrow',
        }
      }
    }
  } catch (err) {
    console.warn('Thanks splash Firestore read failed:', err)
  }

  try {
    const functions = getFunctions(app)
    const getThanksSplash = httpsCallable<Record<string, never>, GetThanksSplashResponse>(
      functions,
      'getThanksSplash',
      { timeout: 180_000 }
    )
    const result = await getThanksSplash({})
    if (!result.data?.success || !result.data.imageUrl) return null
    return {
      dayKey: result.data.dayKey || dayKey,
      imageUrl: result.data.imageUrl,
      subtitle: result.data.subtitle || 'See you tomorrow',
    }
  } catch (err) {
    console.warn('Thanks splash callable failed:', err)
    return null
  }
}
